import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../assets/images/svg_icons/flag-usa.svg'

function SvgComponent() {
  return <DefaultLogo />
}

export default SvgComponent
